export default __webpack_public_path__ + "static/media/25110801.df199a72.png";